import { render, staticRenderFns } from "./ModalUnlink.vue?vue&type=template&id=0e0fc182"
import script from "./ModalUnlink.vue?vue&type=script&lang=js"
export * from "./ModalUnlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0fc182')) {
      api.createRecord('0e0fc182', component.options)
    } else {
      api.reload('0e0fc182', component.options)
    }
    module.hot.accept("./ModalUnlink.vue?vue&type=template&id=0e0fc182", function () {
      api.rerender('0e0fc182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/ModalUnlink.vue"
export default component.exports